"use client";

import { useLingui } from "@lingui/react/macro";
import { EditIcon } from "@offstreetparking/design-system/icons/EditIcon";
import type { ParkerVehicle } from "./parker-vehicle";

type EditVehicleButtonProps = {
	vehicle: ParkerVehicle;
	onClick: () => void;
};

export const EditVehicleButton = ({ vehicle, onClick }: EditVehicleButtonProps) => {
	const { t } = useLingui();
	const vehicleLabel = vehicle.nickname || t`Untitled Vehicle`;
	return (
		<button
			type="button"
			className="shrink-0 text-accent"
			aria-label={t`Edit "${vehicleLabel}" vehicle information`}
			onClick={onClick}
		>
			<EditIcon className="h-6 w-6" />
		</button>
	);
};
